import { adminService } from '@/api/services';
import type { UnwrapData } from '@/api/types';

import type { IAdmissionSurvey, IAdmissionSurveyResponse, TAdmissionSurveyPayload } from './types';

export const admissionSurveyService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить опрос панели отбора
     */
    getAdmissionSurvey: builder.query<UnwrapData<IAdmissionSurveyResponse>, { schoolId: number }>({
      query: ({ schoolId }) => ({
        method: 'GET',
        url: `/schools/${schoolId}/admission_survey`,
      }),
      providesTags: (_, __, { schoolId }) => [{ type: 'SchoolAdmissionSurvey', id: schoolId }],
      transformResponse: (response: IAdmissionSurveyResponse): UnwrapData<IAdmissionSurveyResponse> => response.data,
    }),
    /**
     * Создать опрос панели отбора
     */
    createAdmissionSurvey: builder.mutation<
      IAdmissionSurvey,
      { schoolId: number; surveyData: TAdmissionSurveyPayload }
    >({
      query: ({ schoolId, surveyData: { title, start_date, end_date, active } }) => ({
        method: 'POST',
        url: `/schools/${schoolId}/admission_survey`,
        body: {
          data: { title, start_date, end_date, active },
        },
      }),
      invalidatesTags: (_, __, { schoolId }) => [{ type: 'SchoolAdmissionSurvey', id: schoolId }],
    }),
    /**
     * Обновить опрос панели отбора
     */
    updateAdmissionSurvey: builder.mutation<
      IAdmissionSurvey,
      { schoolId: number; surveyData: TAdmissionSurveyPayload }
    >({
      query: ({ schoolId, surveyData: { title, start_date, end_date, active } }) => ({
        method: 'PATCH',
        url: `/schools/${schoolId}/admission_survey`,
        body: {
          data: { title, start_date, end_date, active },
        },
      }),
      invalidatesTags: (_, __, { schoolId }) => [{ type: 'SchoolAdmissionSurvey', id: schoolId }],
    }),
  }),
});

export const { useGetAdmissionSurveyQuery, useCreateAdmissionSurveyMutation, useUpdateAdmissionSurveyMutation } =
  admissionSurveyService;
